import '../style.css'

export const Fraction = ({ value, state, fromtop=false, mixed=false }) => {

    if (mixed) {
        const parts = value.split(' ');
    
        if (parts.length === 1) {
            return (
                <div className={`flex items-center justify-center w-[41px] xs:w-[55.87px] sm:w-[40px] 
                ${state
                    ? 'xl:w-[96px] lg:w-[72px] md:w-[55.87px]'
                    : 'xl:w-[113.87px] lg:w-[93.16px] md:w-[61px]'
                  }
                  ${fromtop
                    ? (state ? 'toppartTextState ' : 'toppartTextNotState ')
                    : (state ? 'bottompartTextState ' : 'bottompartTextNotState ')
                  } `}>
                {value}
                </div>
            );
        }
    
        const [whole, fraction] = parts;
        const [num, den] = fraction.split('/');
        return (
            <div className={`flex items-center gap-1  
            ${fromtop
                ? (state ? 'toppartTextState ' : 'toppartTextNotState ')
                : (state ? 'bottompartTextState ' : 'bottompartTextNotState ')
              }"}`}>
                <div className={`${fromtop ? "xl:mr-[30px] lg:mr-[25px] md:mr-[20px] sm:mr-[15px] mr-[18px]" : 'mr-0'}`}>{whole}</div>
    
                <div className={`flex flex-col items-center leading-none w-[41px] xs:w-[55.87px] sm:w-[40px] ${state ? "xl:w-[96px] lg:w-[72px] md:w-[55.87px]" : "xl:w-[113.87px] lg:w-[93.16px] md:w-[61px]"}`}>
                    <div>{num}</div>
                    <div
                        className={` border-t-[2px] ${
                            fromtop ? "border-purple-700 w-full" : "w-[70%]"
                        } my-[2px]`}
                    />
                    <div>{den}</div>
                </div>
            </div>
        );
    }

    const [num, den] = value.split('/');


    if (Number(num) === 0) {
        return (
            <div className={`flex items-center justify-center w-[41px] xs:w-[55.87px] sm:w-[40px]
             ${state ? "xl:w-[96px] lg:w-[72px] md:w-[55.87px]" : "xl:w-[113.87px] lg:w-[93.16px] md:w-[61px]" } 
             ${fromtop
                ? (state ? 'toppartTextState ' : 'toppartTextNotState ')
                : (state ? 'bottompartTextState ' : 'bottompartTextNotState ')
              }`}>
                0
            </div>
        );
    } else if (Number(num) === Number(den)) {
        return (
            <div className={`flex items-center justify-center w-[41px] xs:w-[55.87px] sm:w-[40px] 
            ${state ? "xl:w-[96px] lg:w-[72px] md:w-[55.87px]" : "xl:w-[113.87px] lg:w-[93.16px] md:w-[61px]" } 
            ${fromtop
               ? (state ? 'toppartTextState ' : 'toppartTextNotState ')
               : (state ? 'bottompartTextState ' : 'bottompartTextNotState ')
             }`}>
                1
            </div>
        );
    } else if (Number(den) === 1) {
        return (
            <div className={`flex items-center justify-center w-[41px] xs:w-[55.87px] sm:w-[40px] 
            ${state ? "xl:w-[96px] lg:w-[72px] md:w-[55.87px]" : "xl:w-[113.87px] lg:w-[93.16px] md:w-[61px]" } 
            ${fromtop
               ? (state ? 'toppartTextState ' : 'toppartTextNotState ')
               : (state ? 'bottompartTextState ' : 'bottompartTextNotState ')
             }`}>
                {num}
            </div>
        );
    }

    return (
        <div className={`flex flex-col items-center leading-none w-[41px] xs:w-[55.87px] sm:w-[40px]  
        ${state ? "xl:w-[96px] lg:w-[72px] md:w-[55.87px]" : "xl:w-[113.87px] lg:w-[93.16px] md:w-[61px]" } 
        ${fromtop
           ? (state ? 'toppartTextState ' : 'toppartTextNotState ')
           : (state ? 'bottompartTextState ' : 'bottompartTextNotState ')
         }`}>
            <div>{num}</div>
            <div className={` border-t-[2px] ${fromtop ? "border-purple-700 w-full" : 'w-[70%]'} my-[2px]`} />
            <div>{den}</div>
        </div>
    );
};